import { unitTypes } from "@/settings/unitTypes";
export default {
  methods: {
    savePressure: function(valueStored, newUnit) {
      if (newUnit === "bar") return valueStored;
      if (newUnit === "kPa") return valueStored / 100;
      if (newUnit === "psi") return valueStored * 0.0689475728;
      if (newUnit === "atm") return valueStored / 1.01325;
    },
    saveTemperature: function(valueStored, newUnit) {
      if (newUnit === "°C") return valueStored;
      if (newUnit === "K") return valueStored - 273.15;
      if (newUnit === "°F") return (valueStored - 32) * (5 / 9);
      if (newUnit === "°R") return (valueStored - 491.67) * (5 / 9);
    },
    saveFlow: function(valueStored, newUnit) {
      if (newUnit === "l/h") return valueStored;
      if (newUnit === "m³/s") return valueStored * (3.6 * 10 ** 6);
      if (newUnit === "m³/h") return valueStored * 1000;
      if (newUnit === "GPM") return valueStored * 227;
      if (newUnit === "ft³/h") return valueStored * 28.317;
      if (newUnit === "MMSCFD") return valueStored * 326.99;
    },
    saveAngularSpeed: function(valueStored, newUnit) {
      if (newUnit === "rad/s") return valueStored;
      if (newUnit === "rpm") return valueStored * 0.10472;
    },
    savePercentage: function(valueStored, newUnit) {
      if (newUnit === "%") return valueStored;
      if (newUnit === "relative") return valueStored * 100;
    },
    savePower: function(valueStored, newUnit) {
      if (newUnit === "kW") return valueStored;
      if (newUnit === "hp") return valueStored / 1.34102;
    },
    saveVolume: function(valueStored, newUnit) {
      if (newUnit === "l") return valueStored;
      if (newUnit === "m³") return valueStored * 1000;
      if (newUnit === "gal") return valueStored * 4.54609;
    },
    saveMassFlow: function(valueStored, newUnit) {
      if (newUnit === "kg/h") return valueStored;
      if (newUnit === "lb/h") return valueStored / 2.204621;
    },
    saveLength: function(valueStored, newUnit) {
      if (newUnit === "m") return valueStored;
      if (newUnit === "in") return valueStored * 0.0254;
      if (newUnit === "ft") return valueStored / 0.3048;
    },
    saveVibration: function(valueStored, newUnit) {
      if (newUnit === "μm") return valueStored;
      if (newUnit === "mils") return valueStored * 25.4;
    },
    saveUnit: function(value, type, unit) {
      if (!(typeof value == "number")) {
        value = parseFloat(value.replace(/,/, "."));
      }
      if (type === unitTypes.pressure) return this.savePressure(value, unit);
      if (type === unitTypes.temperature)
        return this.saveTemperature(value, unit);
      if (type === unitTypes.flow || type === unitTypes.outputFlow)
        return this.saveFlow(value, unit);
      if (type === unitTypes.percentage)
        return this.savePercentage(value, unit);
      if (type === unitTypes.angularSpeed)
        return this.saveAngularSpeed(value, unit);
      if (type === unitTypes.power) return this.savePower(value, unit);
      if (type === unitTypes.volume) return this.saveVolume(value, unit);
      if (type === unitTypes.massFlow) return this.saveMassFlow(value, unit);
      if (type === unitTypes.length) return this.saveLength(value, unit);
      if (type === unitTypes.vibration) return this.saveVibration(value, unit);
      if (
        type === unitTypes.voltage ||
        type === unitTypes.frequency ||
        type === unitTypes.electricCurrent ||
        type === unitTypes.capacity ||
        type === unitTypes.pH ||
        type === unitTypes.conductivity ||
        type === unitTypes.electricalPower ||
        type === unitTypes.unique ||
        type === unitTypes.deathLine ||
        type === unitTypes.steps
      )
        return value;
    }
  }
};
